import { loader } from "../type";


const LoaderReducer = (state = 0, action)=>{
    if(action.type === loader.startLoader){
        state = 1;
    }
    else if( action.type === loader.stopLoader) {
        state = 0;
    }
    return state;
}

export default LoaderReducer 
